import React from "react";
import "./Clients.css";
import star from "../../assets/svg/star-svgrepo-com 1.svg";
import home from "../../assets/svg/home-svgrepo-com 2.svg";
import suitcase from "../../assets/svg/suitcase-svgrepo-com 2.svg";
import Edit from "../../assets/svg/Edit.svg";
import Map from "../../assets/images/Map.png";

export default function Locations_clientInfo() {
  return (
    <>
      <div className="container_Locations_clientInfo">
        <div className="locationStily">
          <h1 className="Locations_clientInfo_header">Saved Places</h1>
          <div className="Locations_clientInfo_section">
            <h2 className="subHeader">
              <span>
                <img src={suitcase} alt="" /> Home
              </span>
              <img src={Edit} alt="" />
            </h2>
            <p className="address">
              3751401 البنوك محافظة الدقم، قسم الدقم، الحكومة، مكة
            </p>
          </div>

          <div className="Locations_clientInfo_section">
            <h2 className="subHeader">
              <span>
                <img src={home} alt="" /> Work
              </span>
              <img src={Edit} alt="" />
            </h2>
            <p className="address">
              4470702 القاهرة محافظة التابعة، قسم المجال شارع177
            </p>
          </div>

          <div className="Locations_clientInfo_section">
            <h2 className="subHeader">
              <span>
                <img src={star} alt="" /> Home 2
              </span>
              <img src={Edit} alt="" />
            </h2>
            <p className="address">
              209C-010, 4730114 القاهرة محافظة الجديدة، القاهرة أول قسم
            </p>
          </div>

          <div className="Locations_clientInfo_section">
            <h2 className="subHeader">
              <span>
                <img src={star} alt="" /> Company
              </span>
              <img src={Edit} alt="" />
            </h2>
            <p className="address">
              383R-006, 4450301 القاهرة محافظة نجر مجلة السادسة المحلطة
            </p>
          </div>
        </div>
        <div className="locationStily_img">
          <img src={Map} alt="" />
        </div>
      </div>
    </>
  );
}
